import {
  UPDATE_MODULE_DATA_SUCCESS, MODULE_LIST_SUCCESS, MODULE_LIST_FILTER_UPDATE, MODULE_LIST_PAGE_UPDATE,
  MODULE_EDIT_METADATA_SUCCESS, MODULE_EDIT_METADATA_UPDATE, MODULE_LIST_SORT, MODULE_PAGE_PREVIEW_SUCCESS,
  SAVE_MODULE_SUCCESS,
  FETCH_SURVEY_RESPONSE_SUCCESS,
  USER_ASSIGNED_COUNTRY_LIST_SUCCESS,
  GET_QUESTION_VERSIONS_SUCCESS,
  UNMOUNT_PREVIEW_RESPONSE_SUCCESS,
  UNMOUNT_MODULE_LIST_RESPONSE_SUCCESS,
  UNMOUNT_USER_ASSIGNED_COUNTRY_LIST_SUCCESS,
  FETCH_SURVEY_RESPONSE_OFFLINE_SUCCESS,
  SYNC_SURVEY_RESPONSE_OFFLINE_SUCCESS,
  SET_OFFLINE_MODE_SUCCESS,
  SYNC_SURVEY_RESPONSE_OFFLINE_COMPLETED_SUCCESS, /* SAVE_MODULE_QUESTIONS_SUCCESS */
} from '../constants/constants';

export function ModelReducer(state = {
  moduleId: null,
  isUpdated: false,
  editModuleMetadata: {},
  models: [],
  filter: {
    logic: "and",
    filters: []
  },
  page: {
    skip: 0,
    take: 10
  },
  sort: [],
  pagePreview: {},
  pages: [],
  response: {},
  questionVersions: [],
  countryData: {},
  syncOffline: false,
  isOfflineModeActivated: false
}, action: any) {
  switch (action.type) {
    case MODULE_LIST_SUCCESS:
      return {
        ...state,
        models: action.payload.data.payload
      }

    case MODULE_LIST_FILTER_UPDATE:
      return {
        ...state,
        filter: action.payload
      }

    case MODULE_LIST_PAGE_UPDATE:
      return {
        ...state,
        page: action.payload
      }

    case MODULE_LIST_SORT:
      return {
        ...state,
        sort: action.payload
      }

    case MODULE_EDIT_METADATA_SUCCESS:
      return {
        ...state,
        editModuleMetadata: action.payload.data.payload
      }

    case MODULE_EDIT_METADATA_UPDATE:
      return {
        ...state,
        editModuleMetadata: action.payload
      }

    case UPDATE_MODULE_DATA_SUCCESS:
      return {
        ...state,
        editModuleMetadata: action.payload.editModuleMetadata,
        isUpdated: !state.isUpdated
      }

    case MODULE_PAGE_PREVIEW_SUCCESS:
      return {
        ...state,
        response: action.payload.response.data.payload
      }
    case SAVE_MODULE_SUCCESS:
      return {
        ...state,
        moduleId: action.payload.data.payload
      }
    case FETCH_SURVEY_RESPONSE_SUCCESS:
      return {
        ...state,
        response: action.payload.response.data.payload
      }

    case FETCH_SURVEY_RESPONSE_OFFLINE_SUCCESS:
      console.log(action.payload);
      return {
        ...state,
        response: action.payload.response.data.payload,
        isOfflineModeActivated: true,
        syncOffline: false
      }

    case SYNC_SURVEY_RESPONSE_OFFLINE_SUCCESS:
      console.log(action.payload);
      return {
        ...state,
        syncOffline: action.payload.response.data.payload,
        isOfflineModeActivated: false
      }

    case SYNC_SURVEY_RESPONSE_OFFLINE_COMPLETED_SUCCESS:
      return {
        ...state,
        syncOffline: false
      }

    case SET_OFFLINE_MODE_SUCCESS:
      return {
        ...state,
        isOfflineModeActivated: action.payload.data.payload
      }

    case USER_ASSIGNED_COUNTRY_LIST_SUCCESS:
      return {
        ...state,
        countryData: action.payload.response.data.payload,
      }

    case GET_QUESTION_VERSIONS_SUCCESS:
      return {
        ...state,
        questionVersions: action.payload.response.data.payload

      }
    case UNMOUNT_PREVIEW_RESPONSE_SUCCESS:
      return {
        ...state,
        response: action.payload
      }

    case UNMOUNT_MODULE_LIST_RESPONSE_SUCCESS:
      return {
        ...state,
        response: action.payload
      }
    case UNMOUNT_USER_ASSIGNED_COUNTRY_LIST_SUCCESS:
      return {
        ...state,
        countryData: null
      }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer.module.tsx